module.exports = __webpack_public_path__ + "img/2.0ce708c5.png";